import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Stack from "@mui/material/Stack";
// routes
import { RouterLink } from '../../routes/components';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = true, sx, mini = false, ...other }, ref) => {
  const theme = useTheme();
  const logo = (
      <>
        <Stack direction="row" sx={{...sx}} spacing={1} >
          {mini ? 
            <Box
                component="img"
                src="/logo/IA.png"
                sx={{ width: 50, ...sx }}
            />
          :
            <Box
                component="img"
                src="/logo/Categorizia-positivo.png"
                sx={{ width: 190 }}
            />}
        </Stack>

      </>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
  mini: PropTypes.bool,
};

export default Logo;
